import React from 'react'
import { ReactComponent as ForumIcon } from 'assets/icons/forum.svg'
import { ReactComponent as AnalyticsIcon } from 'assets/icons/analitic.svg'
import { ReactComponent as LightbulbIcon } from 'assets/icons/lightbulb.svg'
import { ReactComponent as BugIcon } from 'assets/icons/bug_report.svg'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import { ReactComponent as WhatsAppIcon } from 'assets/icons/whatsapp.svg'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import Header from '../Header/Header'
import ContactRoute from '../ContactRoute/ContactRoute'
import { CEO_CONTACT, SUPPORT_ROUTES } from '../../data/settingsData'
import s from './Support.module.scss'

const ROUTE_ICONS = {
	forum: ForumIcon,
	analytics: AnalyticsIcon,
	lightbulb: LightbulbIcon,
	bug: BugIcon,
}

export const Support = ({ goBack }) => (
	<>
		<Header
			title="Contact us"
			description="Choose a topic and we’ll start a correctly tagged email for you."
			onBack={goBack}
		/>
		<section className={s.support__routes} aria-label="Contact topics">
			{SUPPORT_ROUTES.map(route => (
				<ContactRoute key={route.id} {...route} icon={ROUTE_ICONS[route.iconKey]} />
			))}
		</section>
		<section className={s.support__hero}>
			<div className={s.support__identity}>
				<InitialAvatar name={CEO_CONTACT.name} size={48} />
				<div>
					<h2 className={s.support__name}>{CEO_CONTACT.name}</h2>
					<span className={s.support__role}>{CEO_CONTACT.role}</span>
				</div>
			</div>
			<div className={s.support__contact}>
				<a href={`mailto:${CEO_CONTACT.email}`} className={s.support__link}>
					<MailIcon aria-hidden />
					<span>
						<small className={s.support__linkLabel}>Email</small>
						<strong className={s.support__linkValue}>{CEO_CONTACT.email}</strong>
					</span>
				</a>
				<a
					href={CEO_CONTACT.whatsappHref}
					target="_blank"
					rel="noopener noreferrer"
					className={s.support__link}
				>
					<WhatsAppIcon aria-hidden />
					<span>
						<small className={s.support__linkLabel}>Send to WhatsApp</small>
						<strong className={`${s.support__linkValue} ${s.support__whatsappValue}`}>
							{CEO_CONTACT.whatsapp}
						</strong>
					</span>
				</a>
			</div>
		</section>
	</>
)

export default Support
